import { useQuery } from '@tanstack/react-query';

import { ROOMS_LIST_STALE_TIME } from '~teacher/hook/room/constants';
import { roomsKeys } from '~teacher/hook/room/roomsKeys';

import { Room, getRoomsList } from '../../../api/rooms/getRoomsList';

interface UseRoomsListParams<T = Array<Room>> {
  select?: (rooms: Array<Room>) => T;
  enabled?: boolean;
}

export function useRoomsList<T = Array<Room>>({
  select,
  enabled = true,
}: UseRoomsListParams<T> = {}) {
  return useQuery({
    staleTime: ROOMS_LIST_STALE_TIME,
    queryKey: roomsKeys.list(),
    queryFn: getRoomsList,
    enabled: enabled,
    select: select,
  });
}
